"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ctransposeDependencies = void 0;
var _dependenciesConjGenerated = require("./dependenciesConj.generated.js");
var _dependenciesTransposeGenerated = require("./dependenciesTranspose.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var ctransposeDependencies = exports.ctransposeDependencies = {
  conjDependencies: _dependenciesConjGenerated.conjDependencies,
  transposeDependencies: _dependenciesTransposeGenerated.transposeDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createCtranspose: _factoriesAny.createCtranspose
};